/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 08 2024
 **/

import { useTheme } from "@emotion/react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function CircularProgress({
	value,
	trailColor,
	pathColor,
	className,
	strokeWidth = 16
}: {
	value: number;
	trailColor?: string;
	pathColor?: string;
	strokeWidth?: number;
	className?: string;
}) {
	const theme = useTheme();

	return (
		<CircularProgressbar
			className={className}
			value={value}
			strokeWidth={strokeWidth}
			styles={buildStyles({
				trailColor: trailColor ?? theme.colors.neutral_20_100,
				pathColor: pathColor ?? theme.colors.accent_50_100
			})}
		/>
	);
}
